module.exports = __webpack_public_path__ + "static/img/lucilas-2.e57e049.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/lucilas-2.jpg
// module id = KmAp
// module chunks = 1